const attempt = (func, ...args) => {
  try {
    return func(...args);
  } catch (error) {
    return error;
  }
};

export { attempt };
